import React, { useState } from 'react';
import { Modal } from './Modal';
import { appealService } from '../../services/appealService';

interface AppealModalProps {
  isOpen: boolean;
  onClose: () => void;
  postId: string;
  onSubmitted?: () => void;
  zIndex?: number;
}

export const AppealModal: React.FC<AppealModalProps> = ({ isOpen, onClose, postId, onSubmitted, zIndex = 80 }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (!reason.trim()) { setError('请填写申诉理由'); return; }
    setSubmitting(true);
    setError('');
    try {
      const res = await appealService.submit(postId, reason.trim());
      if (res.success) {
        onSubmitted?.();
        onClose();
      } else {
        setError(res.error || '提交失败');
      }
    } catch {
      setError('提交失败，请重试');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="内容申诉" size="sm" zIndex={zIndex}>
      <div className="space-y-4">
        <p className="text-sm text-gray-500">您的作品因内容审核未通过被下架。如果您认为这是误判，请说明理由，我们将安排人工复审。</p>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">申诉理由</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="请详细说明为什么您认为该内容不应被拦截..."
            rows={4}
            maxLength={500}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
          />
          <div className="text-right text-xs text-gray-400 mt-1">{reason.length}/500</div>
        </div>
        {error && <p className="text-sm text-red-500">{error}</p>}
        <div className="flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">取消</button>
          <button
            onClick={handleSubmit}
            disabled={submitting}
            className="px-6 py-2 text-sm font-medium text-white bg-black rounded-lg hover:bg-gray-800 disabled:opacity-50"
          >
            {submitting ? '提交中...' : '提交申诉'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
